import { getPersonalConfigApi, updatePersonalConfigApi } from '../api/personal';

const eventOn = emitter => {
  emitter.promiseOn('getPersonalConfig', () => {
    return getPersonalConfigApi();
  });

  emitter.promiseOn('updatePersonalConfig', payload => {
    return updatePersonalConfigApi(payload);
  });
};

export default eventOn;
